<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="colophon">Europa Editions<br/>
			214 West 29th Street<br/>
			New York, N.Y. 10001<br/>
			www.europaeditions.com<br/>
			info@europaeditions.com<br/>
			 <br/>
			 <br/>
			This book is a work of fiction. Any references to historical events,<br/>
			real people, or real locales are used fictitiously. <br/>
			 <br/>
			Copyright © 2019 by Edizioni e/o<br/>
			First Publication 2020 by Europa Editions<br/>
			 <br/>
			Translation by Ann Goldstein<br/>
			Original title:<em class="italic"> La vita bugiarda degli adulti</em><br/>
			Translation copyright © 2020 by Europa Editions<br/>
			 <br/>
			All rights reserved, including the right of reproduction<br/>
			in whole or in part in any form.<br/>
			 <br/>
			Book design by Emanuele Ragnisco<br/>
			www.mekkanografici.com<br/>
			Cover photo © Dmitriy Bilous/Getty Images <br/>
<br/>
			ISBN 9781609455927</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// lying-life-2.vue?9b8ef6da